// I filtri della colonna sinistra di Messaggi: la vista «Stato» e il periodo
// di partenza. Fuori da MessaggiPage.tsx per il tetto righe.
import type { StatoTone } from "@/features/ordini/components/statoToni";

// Filtri "Stato" della sidebar (Davide 2026-07-01): 4 viste mutuamente
// esclusive, niente più toggle "Solo non letti"/"Da rispondere". Semantica
// backend (param ``view``): Da gestire = da rispondere (ultimo = cliente);
// In corso = gestito, ultimo msg < 7gg; Chiusi = ultimo msg ≥ 7gg.
// Redesign 2026-10-27: ogni vista ha il colore di un'etichetta di stato della
// pagina ordini (arancio = da fare, come «Da evadere»).
export const STATUS_FILTERS: Array<{ value: string; label: string; tono: StatoTone }> = [
  { value: "", label: "Tutti", tono: "annullato" },
  { value: "da_gestire", label: "Da gestire", tono: "in-corso" },
  { value: "in_corso", label: "In corso", tono: "spedito" },
  { value: "chiusi", label: "Chiusi", tono: "ordinato" },
  // Davide 30/10: le mail fermate dall'antispam (``mail/spam.py``). Si
  // leggono solo qui e non contano altrove; «Non è spam» le rimette fra i clienti.
  { value: "spam", label: "Spam", tono: "non-ordinato" },
];

// Replica legacy ``tab_messaggi.py:237 _date_from_filter``: di default
// mostriamo solo i thread con attivita' negli ultimi 30 giorni. Davide
// puo' allargare/restringere il range via i due input data nella sidebar.
export function defaultDateFrom(): string {
  const now = new Date();
  now.setDate(now.getDate() - 30);
  return now.toISOString().slice(0, 10);
}
